import request from '@/utils/request'

// 意见反馈--提交  弃用
export function feedback (params) {
  return request({
    url: '/v3/manager/unauth/feedback',
    method: 'post',
    data: params
  })
}
// 意见反馈列表页--分页列表 弃用
export function pageUserFeedback (params) {
  return request({
    url: '/v3/manager/unauth/pageUserFeedback',
    method: 'post',
    data: params
  })
}
// 意见反馈列表页--提交处理客户反馈 弃用
export function updateFeedback (params) {
  return request({
    url: '/v3/manager/unauth/updateFeedback',
    method: 'post',
    data: params
  })
}
// 用户信息
export function userV3PageList (params) {
  return request({
    url: '/v3/user/user/userV3PageList',
    method: 'post',
    data: params
  })
}
// 编辑用户信息0--提交
export function updateById (params) {
  return request({
    url: '/v3/user/user/updateById',
    method: 'post',
    data: params
  })
}
// 修改用户密码--提交
export function resetPassword (params) {
  return request({
    url: '/v3/user/user/resetPassword',
    method: 'post',
    data: params
  })
}



// 充电器信息
export function getChargeInfo (params) {
  return request({
    url: '/v3/canbus/getLastMcuChargerInfo?mcuId=' + params.chargerId,
    method: 'post',
    data: params
  })
}

// 曲线获取
export function manufacturerList () {
  return request({
    url: '/v3/manager/curveNumberInfo/manufacturerList',
    method: 'get'
  })
}

export function descriptionList (m) {
  return request({
    url: '/v3/manager/curveNumberInfo/descriptionList?manufacturer=' + m,
    method: 'get'
  })
}
export function descriptionList2 (data) {
  return request({
    url: '/v3/manager/curveNumberInfo/descriptionList2?manufacturer=' + data.manufacturer + '&model=' + data.model,
    method: 'get'
  })
}

export function findCurveBase (params) {
  return request({
    url: '/v3/manager/curveNumberInfo/findCurveBase',
    method: 'post',
    data: params
  })
}
// 获取曲线名称
export function getSimpleCurve (num) {
  return request({
    url: '/v3/manager/curveNumberInfo/getSimpleCurveNumberInfo?curveNumber=' + num,
    method: 'get'
  })
}

// 更新设备曲线
export function updateDeviceCurve (params) {
  return request({
    url: '/v3/manager/deviceManage/updateDeviceCurve',
    method: 'post',
    data: params
  })
}

// 修改曲线完成，触发mqtt更新数据
export function touchChargerInfo (mcuId) {
  return request({
    url: '/v3/manager/chargerMsg/getChargerInfo?mcuId=' + mcuId,
    method: 'post',
    data: {}
  })
}

// 查询记录，触发更新记录
export function touchChargerRecord (mcuId) {
  return request({
    url: '/v3/manager/chargerMsg/getChargerRecord?mcuId=' + mcuId,
    method: 'post',
    data: {}
  })
}

// 获取语言
export function getProjectValueMap (language) {
  return request({
    url: '/v3/manager/i18n/getProjectValueMap',
    method: 'post',
    data: {
      project: 'admin2020'
    },
    headers: {
      language
    }
  })
}

export function getModuleValueMap (language, data) {
  return request({
    url: '/v3/manager/i18n/getModuleValueMap',
    method: 'post',
    data,
    headers: {
      language
    }
  })
}

export function getI18nValueMap (language, data) {
  return request({
    url: '/v3/manager/i18n/getValueMap',
    method: 'post',
    data,
    headers: {
      language
    }
  })
}



// 获取充电器信息
export function getQrCodeData (sn) {
  return request({
    url: '/v3/manager/charger/getQrCodeData?sn=' + sn,
    method: 'post',
    data: {}
  })
}

// 获取固件升级配置
export function getVersionConfig () {
  return request({
    url: '/v3/manager/deviceFirmwareVersionNotify/deviceFirmwareVersionConfig',
    method: 'get'
  })
}


// 检查版本
export const checkUpdate = (data) => {
  return request({
    url: '/v3/manager/appVersionInfo/checkUpdate',
    method: 'post',
    data
  })
}